<template>
  <div class="relative p-6 bg-white shadow rounded space-y-6">
    <div class="space-y-4">
      <h1 class="text-2xl font-bold">
        All Staff Insights
      </h1>
      <div class="flex flex-wrap items-center justify-between gap-3">
        <InsightsDatePicker embedded />
        <div class="inline-flex rounded border border-gray-300 bg-gray-50 p-0.5 text-xs font-semibold text-gray-600">
          <button
            type="button"
            class="rounded px-3 py-1.5 transition-colors"
            :class="viewMode === 'heatmap' ? 'bg-white text-gray-900 shadow-sm' : 'hover:text-gray-900'"
            @click="viewMode = 'heatmap'"
          >
            Heatmap
          </button>
          <button
            type="button"
            class="rounded px-3 py-1.5 transition-colors"
            :class="viewMode === 'bar' ? 'bg-white text-gray-900 shadow-sm' : 'hover:text-gray-900'"
            @click="viewMode = 'bar'"
          >
            Graph
          </button>
        </div>
      </div>
    </div>

    <!-- 1) Pass in the array of IDs you want to hide -->
    <ActivitiesHeatmap
      v-model:view-mode="viewMode"
      :excluded-ids="excludedIds"
    />

    <!-- 2) Error state -->
    <div
      v-if="eiStore.error"
      class="text-red-500 py-4 text-center"
    >
      {{ eiStore.error }}
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useEmployeeInsightsStore } from '@/pinia/employeeInsightsStore'
import ActivitiesHeatmap from '@/EmployeeInsightsComponents/ActivitiesHeatmap.vue'
import InsightsDatePicker from '@/EmployeeInsightsComponents/InsightsDatePicker.vue'

const eiStore = useEmployeeInsightsStore()
const excludedIds = ref([1,2,3])  // ← Edit this array to exclude employee IDs
const storedViewMode = (() => {
  if (typeof window === 'undefined') return null
  return window.localStorage.getItem('employeeInsightsViewMode')
})()
const viewMode = ref(storedViewMode === 'heatmap' ? 'heatmap' : 'bar')

onMounted(() => {
  eiStore.fetchAllStaff()
})
</script>

<style scoped>
@keyframes spin-reverse {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(-360deg); }
}
.animate-spin-reverse {
  animation: spin-reverse 1.5s linear infinite;
}
</style>
